import http from "@/common/http"

export const detail = (id) =>{
  return http({
    url:"/cont/hotel/detail",
    method:"get",
    data:{
      id
    }
  })
}

export const list = (data) =>{
  return http({
    url:"/cont/hotel/list",
    method:"post",
    data:data
  })
}

export default {
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/hotel.js